import _get from "lodash/get";
import React, { Component } from 'react';
import classnames from 'classnames';
import Image from 'swag-client-common/components/ui/image';
import classes from './product-editor.scss';
class ProductEditor extends Component {
  render() {
    const {
      productImage,
      isFullScreenMode
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.wrapper
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Image, {
      alt: "Related product editor image",
      src: _get(productImage, 'url', ''),
      wrapperClassName: classnames({
        [classes.noHeightFitting]: isFullScreenMode
      }, classes.imageWrapper),
      className: classes.image
    })));
  }
}
export default ProductEditor;